'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const PhoneIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.9 20.1C16.8 20.1 16.6 20.1 16.5 20.2C16 20.3 15.5 20.3 15 20.3C8.80005 20.3 3.80005 15.3 3.80005 9.09999C3.80005 8.59999 3.80005 8.09999 3.90005 7.59999C3.90005 7.49999 3.90005 7.29999 4.00005 7.19999C4.00005 6.99999 4.00005 6.89999 4.00005 6.79999C4.50005 4.99999 6.10005 3.79999 8.00005 3.79999C8.20005 3.79999 8.40005 3.79999 8.60005 3.79999C8.70005 4.39999 8.80005 4.99999 9.00005 5.59999C9.40005 6.89999 9.90005 8.09999 10.6 9.19999L7.60005 10.3C7.60005 11 7.80005 11.6 8.00005 12.1C8.70005 13.9 10.1 15.4 11.9 16C12.5 16.2 13.1 16.4 13.7 16.4L14.8 13.4C15.9 14.1 17.1 14.6 18.4 15C19 15.2 19.6001 15.3 20.2001 15.4C20.2001 15.6 20.2001 15.8 20.2001 16C20.2001 18 18.8 19.7 16.9 20.1Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpPhoneIcon = forwardRef(PhoneIcon);

export { VpPhoneIcon as default };
